<template>
  <div v-bind="$attrs" class="absolute w-full z-3 -bottom-1">
    <div :style="{ width: progress + '%', backgroundColor: fillColor }" class="w-0 h-full"></div>
  </div>
</template>

<script>
import { ref, defineComponent, onMounted, onUnmounted } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    timeout: {
      type: Number,
      default: 5000,
    },
    fillColor: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const progress = ref(0);
    let progressInterval;

    // Ease-in-out function for smooth transition
    const easeInOut = (t) => {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    };

    const startProgress = () => {
      let width = 0;
      const duration = props.timeout;
      const startTime = performance.now();

      progressInterval = setInterval(() => {
        const currentTime = performance.now();
        const elapsed = currentTime - startTime;

        const progressFraction = Math.min(elapsed / duration, 1);
        width = easeInOut(progressFraction) * 100;
        progress.value = width;

        if (width >= 100) {
          clearInterval(progressInterval);
          nextSection();
        }
      }, 10);
    };

    const nextSection = () => {
      emit('handleNext');
      progress.value = 0;
      startProgress();
    };

    onMounted(() => {
      startProgress();
    });
    onUnmounted(() => {
      clearInterval(progressInterval);
    });

    return { startProgress, progress };
  },
});
</script>

<style></style>
